export function formatInputValue(value: string | null): string {
    if (!value) {
        return '';
    }

    return value;
}
